// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { layerGroup16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-layer-group': IconLayerGroup;
    }
}

/**
 * The icon component for the 'layerGroup' icon
 */
export class IconLayerGroup extends Icon {
    public constructor() {
        super(layerGroup16X16);
    }
}

registerIcon('icon-layer-group', IconLayerGroup);
export const iconLayerGroupTag = 'nimble-icon-layer-group';
